import { loadTree, saveTree } from './helpers'

export const initialState = loadTree

export const Actions = {
  UPDATE: 'UPDATE',
  CLEAR: 'CLEAR'
}

export const treeReducer = (state, action) => {
  const { type } = action

  switch (type) {
    case Actions.UPDATE:
      return handleUpdate(state, action)
    case Actions.CLEAR:
      return handleClear(state, action)
    default:
      throw new Error(`Unknown ${action._type} tree reducer type: ${type}`)
  }
}

const handleUpdate = (state, action) => {
  const { id, open, _type } = action
  const newState = { ...state, [id]: open }
  saveTree(newState, _type)
  return newState
}

const handleClear = (state, action) => {
  const { exclude, _type } = action
  const newState = {}

  if (exclude) {
    Object.entries(state).forEach(([key, val]) => {
      if (key.startsWith(exclude)) {
        newState[key] = val
      }
    })
  }

  saveTree(newState, _type)
  return newState
}
